import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { useGetStudentDetails } from "../../../../hooks/students";
import { useGetCareersData } from "../../../../hooks/misc";

import { StudentResumeTab } from "../../../../interfaces/student";

import StudentDetailsLayout from "../../../layouts/Student";
import { TabContainer } from "../../../sub_components/Tabs";
import ScanResults from "../../../sub_components/student/resume/scanner/ScanResults";

const ScanDetails = () => {
    const { studentId: studentIdParam, scannerId: scannerIdParam } = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    const studentId = studentIdParam ? parseInt(studentIdParam) : 0;
    const scannerId = scannerIdParam ? parseInt(scannerIdParam) : 0;

    const tabItems = [
        { id: "Builder", label: "Builder" },
        { id: "Scanner", label: "Scanner" },
    ];

    const [currentTab, setCurrentTab] = useState<StudentResumeTab>("Scanner");

    const { data: student } = useGetStudentDetails(studentId);
    const { data: careersData } = useGetCareersData(studentId);

    const resumeScanDetails = careersData?.resume_scans.find((resumeScan) => resumeScan.resume_scan.id === scannerId) ?? null;

    const tab = location.state?.tab ?? null;
    useEffect(() => {
        if (tab) setCurrentTab(tab);
    }, [tab]);

    useEffect(() => {
        const container = document.querySelector(
            ".immersion__common_details__sub_info__forms_container"
        );
        if (container) container.scrollTo(0, 0);
    }, [currentTab]);

    const handleTabChange = (tabId: string) => {
        // setCurrentTab(tabId as StudentResumeTab);
        navigate(`/students/${studentId}/resume`);
    };

    return (
        <StudentDetailsLayout
            goBackRoute={location.state?.goBackRoute ?? null}
            operation="update"
            currentTab="Resume"
            title={student?.first_name + ' ' + student?.last_name}
            error={false}
            linkedStatus={{
                isDataAvailable: !!studentId,
                linked: !!student?.date_linked,
                linkedDate: student?.date_linked ?? null,
                unlinkedDate: student?.date_unlinked ?? null,
            }}
            isStudentAdded={!!student}
        >
            <div className="immersion__common_details__sub_info_container">
                <div className="immersion__common_details__sub_info_view">
                    <TabContainer
                        items={tabItems}
                        activeTab={currentTab}
                        onChange={handleTabChange}
                        variant="content"
                    />
                    <div className="immersion__common_details__sub_info__forms_container">
                        <div className="immersion__resume__scanner_page">
                            {resumeScanDetails && (
                                <ScanResults
                                    studentId={studentId}
                                    resumeTitle={resumeScanDetails.resume.title || `${student?.first_name}_${student?.last_name}_Resume`}
                                    resumeScanDetails={resumeScanDetails}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </StudentDetailsLayout>
    );
};

export default ScanDetails;
